import styled from "styled-components";

export const SettingsMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px;
  width: 100%;
`;
